import React, { Component } from "react";
import { Modal, Form, Row, Col, Button, Tabs, Table, Tooltip, DatePicker, Collapse } from "antd";
import InputForm from "./InputForm";
import "./Form.css";
import axios from 'axios';
import { maskDate } from "../utils/Masker";
import moment from "moment-timezone";
import numeral from "numeral";
import PessoaFrame from './PessoaFrame';
import ModalPadraoForm from './ModalPadraoForm';
import { getUsuario } from "../utils/LoginManager";
import Colors from "../utils/Colors";

const { Item: ItemForm } = Form;
const TabPane = Tabs.TabPane;
const { Column } = Table;
const ButtonGroup = Button.Group;
const Panel = Collapse.Panel;


export const OPCOES_COMBO_TIPO_DOC = [
  { key: '0', label: '0 - ENTRADA' },
  { key: '1', label: '1 - SAÍDA' },
]

export const OPCOES_COMBO_FORMA_PAGTO = [
  { key: '0', label: '0 - PAGTO À VISTA' },
  { key: '1', label: '1 - PAGTO À PRAZO' },
  { key: '2', label: '2 - OUTROS' },
]

export const OPCOES_COMBO_CONS_FINAL = [
  { key: '0', label: '0 - NÃO' },
  { key: '1', label: '1 - SIM' },
]

export const OPCOES_COMBO_FINALIDADE_EMISSAO = [
  { key: '1', label: '1 - NF-E NORMAL' },
  { key: '2', label: '2 - NF-E COMPL' },
  { key: '3', label: '3 - NF-E DE AJUSTE' },
  { key: '4', label: '4 - DEVOLUÇÃO' },
]

export const OPCOES_COMBO_TIPO_ATENDIMENTO = [
  { key: '0', label: '0 - NÃO SE APLICA' },
  { key: '1', label: '1 - OPERAÇÃO PRESENCIAL' },
  { key: '2', label: '2 - OPERAÇÃO NÃO PRESENCIAL, PELA INTERNET' },
  { key: '3', label: '3 - OPERAÇÃO NÃO PRESENCIAL, TELEATENDIMENTO' },
  { key: '4', label: '4 - NFC-E EM OPERAÇÃO COM ENTREGA A DOMICÍLIO' },
  { key: '9', label: '9 - OPERAÇÃO NÃO PRESENCIAL, OUTROS' },
]

export const OPCOES_COMBO_TIPO_FRETE = [
  { key: '0', label: '0 - POR CONTA DO EMITENTE' },
  { key: '1', label: '1 - POR CONTA DO DESTINATÁRIO / REMETENTE' },
  { key: '2', label: '2 - POR CONTA DE TERCEIROS' },
  { key: '9', label: '9 - SEM FRETE' },
]



export const OPCOES_COMBO_ORIGEM = [
  { key: '0', label: '0 - NACIONAL, EXCETO AS INDICADAS NOS CÓDIGOS 3 A 5' },
  { key: '1', label: '1 - ESTRANGEIRA - IMPORTAÇÃO DIRETA, EXCETO A INDICADA NO CÓDIGO 6' },
  { key: '2', label: '2 - ESTRANGEIRA - ADQUIRIDA NO MERCADO INTERNO, EXCETO A INDICADA NO CÓDIGO 7' },
  { key: '3', label: '3 - NACIONAL, MERCADORIA OU BEM COM CONTEÚDO DE IMPORTAÇÃO SUPERIOR A 40% (QUARENTA POR CENTO)' },
  { key: '4', label: '4 - NACIONAL, CUJA PRODUÇÃO TENHA SIDO FEITA EM CONFORMIDADE COM OS PROCESSOS PRODUTIVOS BÁSICOS DE QUE TRATAM O DECRETO-LEI Nº 288/67, E AS LEIS NºS 8.248/91, 8.387/91, 10.176/01 E 11.484/ 07' },
  { key: '5', label: '5 - NACIONAL, MERCADORIA OU BEM COM CONTEÚDO DE IMPORTAÇÃO INFERIOR OU IGUAL A 40% (QUARENTA POR CENTO)' },
  { key: '6', label: '6 - ESTRANGEIRA - IMPORTAÇÃO DIRETA, SEM SIMILAR NACIONAL, CONSTANTE EM LISTA DE RESOLUÇÃO CAMEX' },
  { key: '7', label: '7 - ESTRANGEIRA - ADQUIRIDA NO MERCADO INTERNO, SEM SIMILAR NACIONAL, CONSTANTE EM LISTA DE RESOLUÇÃO CAMEX' },
  { key: '8', label: '8 - NACIONAL, MERCADORIA OU BEM COM CONTEÚDO DE IMPORTAÇÃO SUPERIOR A 70%' },
]

export const OPCOES_COMBO_MODALIDADE = [
  { key: '0', label: '0 - MARGEM VALOR AGREGADO' },
  { key: '1', label: '1 - PAUTA VALOR' },
  { key: '2', label: '2 - PREÇO TABELADO MÁX. (VALOR)' },
  { key: '3', label: '3 - VALOR DA OPERAÇÃO' },
]

export const OPCOES_COMBO_CST_ICMS = [
  { key: '101', label: '101 - Tributada pelo Simples Nacional com permissão de crédito' },
  { key: '102', label: '102 - Tributada pelo Simples Nacional sem permissão de crédito' },
  { key: '103', label: '103 - Isenção do ICMS no Simples Nacional para faixa de receita bruta' },
  { key: '201', label: '201 - Tributada pelo Simples Nacional com permissão de crédito e com cobrança do ICMS por substituição tributária' },
  { key: '202', label: '202 - Tributada pelo Simples Nacional sem permissão de crédito e com cobrança do ICMS por substituição tributária' },
  { key: '203', label: '203 - Isenção do ICMS no Simples Nacional para faixa de receita bruta e com cobrança do ICMS por substituição tributária' },
  { key: '300', label: '300 - Imune' },
  { key: '400', label: '400 - Não tributada pelo Simples Nacional' },
  { key: '500', label: '500 - ICMS cobrado anteriormente por substituição tributária (substituído) ou por antecipação' },
  { key: '900', label: '900 - Outros' },
]

export const OPCOES_COMBO_CST_IPI = [
  { key: '00', label: '00 - ENTRADA COM RECUPERAÇÃO DE CRÉDITO' },
  { key: '01', label: '01 - ENTRADA TRIBUTADA COM ALÍQUOTA ZERO' },
  { key: '02', label: '02 - ENTRADA ISENTA' },
  { key: '03', label: '03 - ENTRADA NÃO-TRIBUTADA' },
  { key: '04', label: '04 - ENTRADA IMUNE' },
  { key: '05', label: '05 - ENTRADA COM SUSPENSÃO' },
  { key: '49', label: '49 - OUTRAS ENTRADAS' },
  { key: '50', label: '50 - SAÍDA TRIBUTADA' },
  { key: '51', label: '51 - SAÍDA TRIBUTADA COM ALÍQUOTA ZERO' },
  { key: '52', label: '52 - SAÍDA ISENTA' },
  { key: '53', label: '53 - SAÍDA NÃO-TRIBUTADA' },
  { key: '54', label: '54 - SAÍDA IMUNE' },
  { key: '55', label: '55 - SAÍDA COM SUSPENSÃO' },
  { key: '99', label: '99 - OUTRAS SAÍDAS' },
]

export const OPCOES_COMBO_CST_PIS = [
  { key: '01', label: '01 - OPERAÇÃO TRIBUTÁVEL COM ALÍQUOTA BÁSICA' },
  { key: '02', label: '02 - OPERAÇÃO TRIBUTÁVEL COM ALÍQUOTA DIFERENCIADA' },
  { key: '03', label: '03 - OPERAÇÃO TRIBUTÁVEL COM ALÍQUOTA POR UNIDADE DE MEDIDA DE PRODUTO' },
  { key: '04', label: '04 - OPERAÇÃO TRIBUTÁVEL MONOFÁSICA - REVENDA A ALÍQUOTA ZERO' },
  { key: '05', label: '05 - OPERAÇÃO TRIBUTÁVEL POR SUBSTITUIÇÃO TRIBUTÁRIA' },
  { key: '06', label: '06 - OPERAÇÃO TRIBUTÁVEL A ALÍQUOTA ZERO' },
  { key: '07', label: '07 - OPERAÇÃO ISENTA DA CONTRIBUIÇÃO' },
  { key: '08', label: '08 - OPERAÇÃO SEM INCIDÊNCIA DA CONTRIBUIÇÃO' },
  { key: '09', label: '09 - OPERAÇÃO COM SUSPENSÃO DA CONTRIBUIÇÃO' },
  { key: '09', label: '09 - OUTRAS OPERAÇÕES DE SAÍDA' },
  { key: '50', label: '50 - OPERAÇÃO COM DIREITO A CRÉDITO - VINCULADA EXCLUSIVAMENTE A RECEITA TRIBUTADA NO MERCADO INTERNO' },
  { key: '51', label: '51 - OPERAÇÃO COM DIREITO A CRÉDITO - VINCULADA EXCLUSIVAMENTE A RECEITA NÃO TRIBUTADA NO MERCADO INTERNO' },
  { key: '52', label: '52 - OPERAÇÃO COM DIREITO A CRÉDITO - VINCULADA EXCLUSIVAMENTE A RECEITA DE EXPORTAÇÃO' },
  { key: '53', label: '53 - OPERAÇÃO COM DIREITO A CRÉDITO - VINCULADA A RECEITAS TRIBUTADAS E NÃO-TRIBUTADAS NO MERCADO INTERNO' },
  { key: '54', label: '54 - OPERAÇÃO COM DIREITO A CRÉDITO - VINCULADA A RECEITAS TRIBUTADAS NO MERCADO INTERNO E DE EXPORTAÇÃO' },
  { key: '55', label: '55 - OPERAÇÃO COM DIREITO A CRÉDITO - VINCULADA A RECEITAS NÃO-TRIBUTADAS NO MERCADO INTERNO E DE EXPORTAÇÃO' },
  { key: '56', label: '56 - OPERAÇÃO COM DIREITO A CRÉDITO - VINCULADA A RECEITAS TRIBUTADAS E NÃO-TRIBUTADAS NO MERCADO INTERNO, E DE EXPORTAÇÃO' },
  { key: '60', label: '60 - CRÉDITO PRESUMIDO - OPERAÇÃO DE AQUISIÇÃO VINCULADA EXCLUSIVAMENTE A RECEITA TRIBUTADA NO MERCADO INTERNO' },
  { key: '61', label: '61 - CRÉDITO PRESUMIDO - OPERAÇÃO DE AQUISIÇÃO VINCULADA EXCLUSIVAMENTE A RECEITA NÃO-TRIBUTADA NO MERCADO INTERNO' },
  { key: '62', label: '62 - CRÉDITO PRESUMIDO - OPERAÇÃO DE AQUISIÇÃO VINCULADA EXCLUSIVAMENTE A RECEITA DE EXPORTAÇÃO' },
  { key: '63', label: '63 - CRÉDITO PRESUMIDO - OPERAÇÃO DE AQUISIÇÃO VINCULADA A RECEITAS TRIBUTADAS E NÃO-TRIBUTADAS NO MERCADO INTERNO' },
  { key: '64', label: '64 - CRÉDITO PRESUMIDO - OPERAÇÃO DE AQUISIÇÃO VINCULADA A RECEITAS TRIBUTADAS NO MERCADO INTERNO E DE EXPORTAÇÃO' },
  { key: '65', label: '65 - CRÉDITO PRESUMIDO - OPERAÇÃO DE AQUISIÇÃO VINCULADA A RECEITAS NÃO-TRIBUTADAS NO MERCADO INTERNO E DE EXPORTAÇÃO' },
  { key: '66', label: '66 - CRÉDITO PRESUMIDO - OPERAÇÃO DE AQUISIÇÃO VINCULADA A RECEITAS TRIBUTADAS E NÃO-TRIBUTADAS NO MERCADO INTERNO, E DE EXPORTAÇÃO' },
  { key: '67', label: '67 - CRÉDITO PRESUMIDO - OUTRAS OPERAÇÕES' },
  { key: '70', label: '70 - OPERAÇÃO DE AQUISIÇÃO SEM DIREITO A CRÉDITO' },
  { key: '71', label: '71 - OPERAÇÃO DE AQUISIÇÃO COM ISENÇÃO' },
  { key: '72', label: '72 - OPERAÇÃO DE AQUISIÇÃO COM SUSPENSÃO' },
  { key: '73', label: '73 - OPERAÇÃO DE AQUISIÇÃO A ALÍQUOTA ZERO' },
  { key: '74', label: '74 - OPERAÇÃO DE AQUISIÇÃO SEM INCIDÊNCIA DA CONTRIBUIÇÃO' },
  { key: '75', label: '75 - OPERAÇÃO DE AQUISIÇÃO POR SUBSTITUIÇÃO TRIBUTÁRIA' },
  { key: '98', label: '98 - OUTRAS OPERAÇÕES DE ENTRADA' },
  { key: '99', label: '99 - OUTRAS OPERAÇÕES' },
]

export const OPCOES_COMBO_CST_COFINS = [
  { key: '01', label: '01 - OPERAÇÃO TRIBUTÁVEL COM ALÍQUOTA BÁSICA' },
  { key: '02', label: '02 - OPERAÇÃO TRIBUTÁVEL COM ALÍQUOTA DIFERENCIADA' },
  { key: '03', label: '03 - OPERAÇÃO TRIBUTÁVEL COM ALÍQUOTA POR UNIDADE DE MEDIDA DE PRODUTO' },
  { key: '04', label: '04 - OPERAÇÃO TRIBUTÁVEL MONOFÁSICA - REVENDA A ALÍQUOTA ZERO' },
  { key: '05', label: '05 - OPERAÇÃO TRIBUTÁVEL POR SUBSTITUIÇÃO TRIBUTÁRIA' },
  { key: '06', label: '06 - OPERAÇÃO TRIBUTÁVEL A ALÍQUOTA ZERO' },
  { key: '07', label: '07 - OPERAÇÃO ISENTA DA CONTRIBUIÇÃO' },
  { key: '08', label: '08 - OPERAÇÃO SEM INCIDÊNCIA DA CONTRIBUIÇÃO' },
  { key: '09', label: '09 - OPERAÇÃO COM SUSPENSÃO DA CONTRIBUIÇÃO' },
  { key: '49', label: '49 - OUTRAS OPERAÇÕES DE SAÍDA' },
  { key: '50', label: '50 - OPERAÇÃO COM DIREITO A CRÉDITO - VINCULADA EXCLUSIVAMENTE A RECEITA TRIBUTADA NO MERCADO INTERNO' },
  { key: '51', label: '51 - OPERAÇÃO COM DIREITO A CRÉDITO - VINCULADA EXCLUSIVAMENTE A RECEITA NÃO TRIBUTADA NO MERCADO INTERNO' },
  { key: '52', label: '52 - OPERAÇÃO COM DIREITO A CRÉDITO - VINCULADA EXCLUSIVAMENTE A RECEITA DE EXPORTAÇÃO' },
  { key: '53', label: '53 - OPERAÇÃO COM DIREITO A CRÉDITO - VINCULADA A RECEITAS TRIBUTADAS E NÃO-TRIBUTADAS NO MERCADO INTERNO' },
  { key: '54', label: '54 - OPERAÇÃO COM DIREITO A CRÉDITO - VINCULADA A RECEITAS TRIBUTADAS NO MERCADO INTERNO E DE EXPORTAÇÃO' },
  { key: '55', label: '55 - OPERAÇÃO COM DIREITO A CRÉDITO - VINCULADA A RECEITAS NÃO-TRIBUTADAS NO MERCADO INTERNO E DE EXPORTAÇÃO' },
  { key: '56', label: '56 - OPERAÇÃO COM DIREITO A CRÉDITO - VINCULADA A RECEITAS TRIBUTADAS E NÃO-TRIBUTADAS NO MERCADO INTERNO, E DE EXPORTAÇÃO' },
  { key: '60', label: '60 - CRÉDITO PRESUMIDO - OPERAÇÃO DE AQUISIÇÃO VINCULADA EXCLUSIVAMENTE A RECEITA TRIBUTADA NO MERCADO INTERNO' },
  { key: '61', label: '61 - CRÉDITO PRESUMIDO - OPERAÇÃO DE AQUISIÇÃO VINCULADA EXCLUSIVAMENTE A RECEITA NÃO-TRIBUTADA NO MERCADO INTERNO' },
  { key: '62', label: '62 - CRÉDITO PRESUMIDO - OPERAÇÃO DE AQUISIÇÃO VINCULADA EXCLUSIVAMENTE A RECEITA DE EXPORTAÇÃO' },
  { key: '63', label: '63 - CRÉDITO PRESUMIDO - OPERAÇÃO DE AQUISIÇÃO VINCULADA A RECEITAS TRIBUTADAS E NÃO-TRIBUTADAS NO MERCADO INTERNO' },
  { key: '64', label: '64 - CRÉDITO PRESUMIDO - OPERAÇÃO DE AQUISIÇÃO VINCULADA A RECEITAS TRIBUTADAS NO MERCADO INTERNO E DE EXPORTAÇÃO' },
  { key: '65', label: '65 - CRÉDITO PRESUMIDO - OPERAÇÃO DE AQUISIÇÃO VINCULADA A RECEITAS NÃO-TRIBUTADAS NO MERCADO INTERNO E DE EXPORTAÇÃO' },
  { key: '66', label: '66 - CRÉDITO PRESUMIDO - OPERAÇÃO DE AQUISIÇÃO VINCULADA A RECEITAS TRIBUTADAS E NÃO-TRIBUTADAS NO MERCADO INTERNO, E DE EXPORTAÇÃO' },
  { key: '67', label: '67 - CRÉDITO PRESUMIDO - OUTRAS OPERAÇÕES' },
  { key: '70', label: '70 - OPERAÇÃO DE AQUISIÇÃO SEM DIREITO A CRÉDITO' },
  { key: '71', label: '71 - OPERAÇÃO DE AQUISIÇÃO COM ISENÇÃO' },
  { key: '72', label: '72 - OPERAÇÃO DE AQUISIÇÃO COM SUSPENSÃO' },
  { key: '73', label: '73 - OPERAÇÃO DE AQUISIÇÃO A ALÍQUOTA ZERO' },
  { key: '74', label: '74 - OPERAÇÃO DE AQUISIÇÃO SEM INCIDÊNCIA DA CONTRIBUIÇÃO' },
  { key: '75', label: '75 - OPERAÇÃO DE AQUISIÇÃO POR SUBSTITUIÇÃO TRIBUTÁRIA' },
  { key: '98', label: '98 - OUTRAS OPERAÇÕES DE ENTRADA' },
  { key: '99', label: '99 - OUTRAS OPERAÇÕES' },
]

export const OPCOES_COMBO_CST_IBS_CBS = [
  { key: '000', label: '000 - TRIBUTAÇÃO INTEGRAL' },
  { key: '010', label: '010 - TRIBUTAÇÃO COM ALÍQUOTAS UNIFORMES – OPERAÇÕES SETOR FINANCEIRO (INSERIDO)' },
  { key: '011', label: '011 - TRIBUTAÇÃO COM ALÍQUOTAS UNIFORMES REDUZIDAS EM 30% e 60% (INSERIDO)' },
  { key: '200', label: '200 - ALÍQUOTA ZERO OU REDUZIDA' },
  { key: '210', label: '210 - ALÍQUOTA REDUZIDA EM 50% E 70% COM REDUTOR DE BASE DE CÁLCULO' },
  { key: '220', label: '220 - ALÍQUOTA FIXA' },
  { key: '221', label: '221 - ALÍQUOTA FIXA PROPORCIONAL' },
  { key: '222', label: '222 - REDUÇÃO DE BASE DE CÁLCULO' },
  { key: '400', label: '400 - ISENÇÃO' },
  { key: '410', label: '410 - IMUNIDADE E NÃO INCIDÊNCIA' },
  { key: '510', label: '510 - DIFERIMENTO' },
  { key: '550', label: '550 - SUSPENSÃO' },
  { key: '620', label: '620 - TRIBUTAÇÃO MONOFÁSICA' },
  { key: '800', label: '800 - TRANSFERÊNCIA DE CRÉDITO' },
  { key: '810', label: '810 - AJUSTES' },
  { key: '820', label: '820 - TRIBUTAÇÃO EM DECLARAÇÃO DE REGIME ESPECÍFICO' },
  { key: '830', label: '830 - Exclusão de base de cálculo' },
]




export default class NotaFiscalEmissaoComplForm extends Component {
  state = {
    registroVenda: {

    },

    registro: {
      nf_idf: 0,
      nf_numero: 0,
      nf_serie: 0,
      nf_status: 0,
      nf_tipo: '',
      situacao_nota: 'NOVA NFE',
      nf_tipo_mov_nf: { key: '', label: '', },
      nf_destinatario: { key: '0', label: '' },
      nf_obs_interna: '',
      nf_dt_emissao: moment().format('DD/MM/YYYY'),
      nf_dt_inclusao: moment().format('DD/MM/YYYY'),
      nf_chave: '',

      nf_emitente: { key: '', label: '', },
      nf_modelo: { key: '', label: '', },
      nf_nat_oper: { key: '', label: '', },
      nf_forma_pagamento: { key: '2', label: '', },
      nf_finalidade_emissao: { key: '1', label: '', },
      nf_consumidor_final: { key: '1', label: '', },
      nf_tipo_documento: { key: '1', label: '', },
      nf_tipo_atendimento: { key: '1', label: '', },

      nff_tipo: { key: '9', label: '', },
      nff_idf_transportadora: { key: '0', label: '', },
      nff_num_volumes: '',
      nff_especie: '',
      nff_marca: '',
      nff_qtde_vol: 0,
      nff_peso_bruto: 0,
      nff_peso_liquido: 0,

      nf_chave_rel: '',
      nfinf_texto: '',

      nf_vlr_total: 0,
      nf_vlr_cofins: 0,
      nf_vlr_desconto: 0,
      nf_vlr_frete: 0,
      nf_vlr_icms: 0,
      nf_vlr_icms_st: 0,
      nf_vlr_ii: 0,
      nf_vlr_ipi: 0,
      nf_vlr_outras_desp: 0,
      nf_vlr_pis: 0,
      nf_vlr_produtos: 0,
      nf_vlr_seguro: 0,
      nf_bc_icms: 0,
      nf_bc_icms_st: 0,

      visualizando: false,
    },

    activeKey: "dados",
    carregandoForm: false,

    listaParTributacao: [],
    listaParCFOP: [],

    OPCOES_COMBO_TIPO_MOV_NF: [],
    OPCOES_COMBO_EMITENTE: [],
    OPCOES_COMBO_CFOP: [],

    listaProdutos: [],
    listaProdutosVenda: [],
  };


  componentDidUpdate(propsAnterior) {
    if (this.props.registroNfe !== propsAnterior.registroNfe) {
      // console.log('componentDidUpdate', this.props.registroNfe)

      this.setState({
        registro: {
          // ...this.state.registro,
          ...this.props.registroNfe.registro.dados,
          nf_destinatario: this.props.registroNfe.nf_destinatario ? this.props.registroNfe.nf_destinatario : this.props.registroNfe.registro.dados.nf_destinatario ? this.props.registroNfe.registro.dados.nf_destinatario : { key: '0', label: '', },
        },
        registroVenda: this.props.registroNfe.registroVenda,
        listaProdutos: this.props.registroNfe.listaProdutosNF ? this.props.registroNfe.listaProdutosNF : [],
        listaProdutosVenda: this.props.registroNfe.listaProdutosVenda ? this.props.registroNfe.listaProdutosVenda : [],
        activeKey: "dados",
      }, () => {

        this.onBuscaTipoMovNF()
        this.onBuscaEmissor()
        this.onBuscaNatOper()
        this.onBuscaParametrosItens()

        if (this.state.registro.nf_idf) {
          this.calculoTotalPedido(this.props.registroNfe.listaProdutosNF);
        }

        this.forceUpdate()
      });
    }
  }

  componentDidMount() {
    const usuario = getUsuario();
    this.setState({ usuario });
  }



  onBuscaTipoMovNF = async () => {
    this.setState({ OPCOES_COMBO_TIPO_MOV_NF: [] })
    axios.get('/tipoMovNF/lista')
      .then(response => {
        const { data } = response;
        const OPCOES_COMBO_TIPO_MOV_NF = data.map(regList => {
          return {
            key: String(regList.tmnf_idf),
            label: regList.tmnf_descricao,
            tmnf_tipo_mov: regList.tmnf_tipo_mov,
            tmnf_gera_financ: regList.tmnf_gera_financ,
            tmnf_gera_estoque: regList.tmnf_gera_estoque,
          }
        });
        this.setState({
          registro: {
            ...this.state.registro,
            nf_tipo_mov_nf: this.props.registroNfe.registro.dados.nf_tipo_mov_nf ? this.props.registroNfe.registro.dados.nf_tipo_mov_nf : OPCOES_COMBO_TIPO_MOV_NF.length ? OPCOES_COMBO_TIPO_MOV_NF[0] : { key: '', label: '', },
          },
          OPCOES_COMBO_TIPO_MOV_NF,
        })
      }).catch(error => {
        console.error(error.response);
      })
  };

  onChangeEmitente = event => {
    const { registro, OPCOES_COMBO_EMITENTE } = this.state;
    this.setState({ OPCOES_COMBO_MODELO: [] })
    const OPCOES_COMBO_MODELO = [];

    const value = event.target.value;
    const id = event.target.id;
    const iInd = OPCOES_COMBO_EMITENTE.findIndex(registro => String(registro.key) === String(value.key));

    if (OPCOES_COMBO_EMITENTE.length) {
      if (OPCOES_COMBO_EMITENTE[iInd].enf_flag_nfce) {
        OPCOES_COMBO_MODELO.unshift({ key: '65', label: '65 - NFCE - NOTA FISCAL CONSUMIDOR ELETRÔNICA' });
      }
      if (OPCOES_COMBO_EMITENTE[iInd].enf_flag_nfe) {
        OPCOES_COMBO_MODELO.unshift({ key: '55', label: '55 - NFE - NOTA FISCAL ELETRÔNICA' });
      }
    }

    registro[id] = value;
    this.setState({
      [id]: value,
      OPCOES_COMBO_MODELO,
      registro: {
        ...this.state.registro,
        nf_serie: this.props.registroNfe.registro.dados.nf_serie ? this.props.registroNfe.registro.dados.nf_serie : OPCOES_COMBO_EMITENTE[iInd].enf_flag_nfe ? OPCOES_COMBO_EMITENTE[iInd].enf_nfe_serie : OPCOES_COMBO_EMITENTE[iInd].enf_flag_nfce ? OPCOES_COMBO_EMITENTE[iInd].enf_nfce_serie : 0,
        nf_modelo: this.props.registroNfe.registro.dados.nf_modelo ? this.props.registroNfe.registro.dados.nf_modelo : OPCOES_COMBO_MODELO.length ? OPCOES_COMBO_MODELO[0] : { key: '', label: '', },
      },
    });
  };

  onBuscaEmissor = async () => {
    this.setState({ OPCOES_COMBO_EMITENTE: [], OPCOES_COMBO_MODELO: [] })
    const OPCOES_COMBO_MODELO = [];
    axios.get('/emitenteNF/lista', {
      params: {
        tipo: 'PROD',
      }
    }).then(response => {
      const { data } = response;
      const OPCOES_COMBO_EMITENTE = data.map(regList => {
        return {
          key: String(regList.enf_idf),
          label: regList.enf_cnpj + ' - ' + regList.enf_razao_social + ' [' + (regList.enf_ambiente === 1 ? 'P' : 'H') + ']',
          enf_emissao_padrao: regList.enf_emissao_padrao,
          enf_cnpj: regList.enf_cnpj,
          enf_ambiente: regList.enf_ambiente,
          enf_flag_nfe: regList.enf_flag_nfe,
          enf_nfe_numero: regList.enf_nfe_numero,
          enf_nfe_serie: regList.enf_nfe_serie,
          enf_flag_nfce: regList.enf_flag_nfce,
          enf_nfce_numero: regList.enf_nfce_numero,
          enf_nfce_serie: regList.enf_nfce_serie,
          enf_token: regList.enf_token,
        }
      });
      if (OPCOES_COMBO_EMITENTE.length) {
        if (OPCOES_COMBO_EMITENTE[0].enf_flag_nfce) {
          OPCOES_COMBO_MODELO.unshift({ key: '65', label: '65 - NFCE - NOTA FISCAL CONSUMIDOR ELETRÔNICA' });
        }
        if (OPCOES_COMBO_EMITENTE[0].enf_flag_nfe) {
          OPCOES_COMBO_MODELO.unshift({ key: '55', label: '55 - NFE - NOTA FISCAL ELETRÔNICA' });
        }
      }
      this.setState({
        registro: {
          ...this.state.registro,
          nf_emitente: this.props.registroNfe.registro.dados.nf_emitente ? this.props.registroNfe.registro.dados.nf_emitente : OPCOES_COMBO_EMITENTE.length ? OPCOES_COMBO_EMITENTE[0] : { key: '', label: '', },
          nf_modelo: this.props.registroNfe.registro.dados.nf_modelo ? this.props.registroNfe.registro.dados.nf_modelo : OPCOES_COMBO_MODELO.length ? OPCOES_COMBO_MODELO[0] : { key: '', label: '', },
        },
        OPCOES_COMBO_EMITENTE,
        OPCOES_COMBO_MODELO,
      })
    }).catch(error => {
      console.error(error.response);
    })
  };


  onBuscaNatOper = async () => {
    this.setState({ OPCOES_COMBO_CFOP: [] })
    axios.get('/cfop/lista')
      .then(response => {
        const { data } = response;
        const OPCOES_COMBO_CFOP = data.map(regList => {
          return {
            key: String(regList.cfop_codigo),
            label: String(regList.cfop_codigo) + ' - ' + regList.cfop_descricao,
          }
        });
        this.setState({
          registro: {
            ...this.state.registro,
            nf_nat_oper: this.props.registroNfe.registro.dados.nf_nat_oper ? this.props.registroNfe.registro.dados.nf_nat_oper : { key: '5102', label: '', },
          },
          OPCOES_COMBO_CFOP,
        })
      }).catch(error => {
        console.error(error.response);
      })
  };


  onBuscaParametrosItens = () => {
    this.setState({ listaParTributacao: [], listaParCFOP: [] })

    axios.get('/parametros/parametros_nfe_tributacao')
      .then(response => {
        this.setState({
          listaParTributacao: response.data,
        })
        var { listaProdutosVenda, listaProdutos } = this.state;
        if ((this.state.registro.nf_idf === 0) || (this.state.registro.nf_idf === '0') || (this.state.registro.nf_idf === '') || (this.state.registro.nf_idf === null)) {

          listaProdutos = [];
          for (var x in listaProdutosVenda) {
            listaProdutos.push({
              nfi_seq: listaProdutos.length + 1,
              nfi_produto: listaProdutosVenda[x].mi_item,
              nfi_prduto_codigo: listaProdutosVenda[x].prod_codigo,
              nfi_descricao_produto: listaProdutosVenda[x].prod_descricao,
              nfi_unid_medida: listaProdutosVenda[x].med_descricao,
              prod_cod_barras: listaProdutosVenda[x].prod_cod_barras,

              prod_grade: listaProdutosVenda[x].prod_grade,
              nfi_item_tamanho: listaProdutosVenda[x].mi_item_tamanho,
              nfi_item_cor: listaProdutosVenda[x].mi_item_cor,
              ptam_descricao: listaProdutosVenda[x].ptam_descricao,
              pcor_descricao: listaProdutosVenda[x].pcor_descricao,

              nfi_ncm: listaProdutosVenda[x].prod_ncm,
              nfi_cfop: { key: response.data.pnfet_cfop ? String(response.data.pnfet_cfop) : '5102' },

              nfi_qtde: parseFloat(listaProdutosVenda[x].mi_qtde),
              nfi_vlr_unitario: parseFloat(listaProdutosVenda[x].mi_vlr_unit),
              nfi_vlr_total: parseFloat(listaProdutosVenda[x].mi_vlr_total),
              nfi_perc_desconto: parseFloat(listaProdutosVenda[x].mi_perc_desc === '' ? '0' : listaProdutosVenda[x].mi_perc_desc),
              nfi_vlr_desconto: parseFloat(listaProdutosVenda[x].mi_vlr_desc === '' ? '0' : listaProdutosVenda[x].mi_vlr_desc),
              nfi_vlr_despesas: parseFloat(listaProdutosVenda[x].mi_vlr_acres === '' ? '0' : listaProdutosVenda[x].mi_vlr_acres),
              nfi_vlr_frete: 0,
              nfi_vlr_seguro: 0,

              nficms_origem: { key: response.data.pnfet_origem_produto ? String(response.data.pnfet_origem_produto) : '0' },
              nficms_modbc: { key: '0' },
              nficms_cst: { key: response.data.pnfet_cst_icms ? String(response.data.pnfet_cst_icms) : '' },
              nficms_vbc: 0,
              nficms_picms: 0,
              nficms_vicms: 0,
              nficms_vbcst: 0,
              nficms_picmsst: 0,
              nficms_vicmsst: 0,

              nfipi_cst: { key: response.data.pnfet_cst_ipi ? String(response.data.pnfet_cst_ipi).padStart(2, '0') : '' },
              nfipi_vbc: 0,
              nfipi_pipi: 0,
              nfipi_vipi: 0,

              nfpis_cst: { key: response.data.pnfet_cst_pis ? String(response.data.pnfet_cst_pis).padStart(2, '0') : '' },
              nfpis_vbc: 0,
              nfpis_ppis: 0,
              nfpis_vpis: 0,

              nfcof_cst: { key: response.data.pnfet_cst_cofins ? String(response.data.pnfet_cst_cofins).padStart(2, '0') : '' },
              nfcof_vbc: 0,
              nfcof_pcofins: 0,
              nfcof_vcofinf: 0,

              nfci_cst: { key: response.data.pnfet_cst_ibs_cbs ? String(response.data.pnfet_cst_ibs_cbs).padStart(3, '0') : '' },
              nfci_sit_trib_ibs_cbs: response.data.pnfet_sit_trib_ibs_cbs ? String(response.data.pnfet_sit_trib_ibs_cbs) : '',
              nfci_bc: 0,
              nfci_pibs_mun: response.data.pnfet_pibs_mun ? response.data.pnfet_pibs_mun : 0,
              nfci_vibs_mun: 0,
              nfci_pibs_est: response.data.pnfet_pibs_est ? response.data.pnfet_pibs_est : 0,
              nfci_vibs_est: 0,
              nfci_pcbs: response.data.pnfet_pcbs ? response.data.pnfet_pcbs : 0,
              nfci_vcbs: 0,
            });

          }

        } else {

          for (var x in listaProdutos) {
            listaProdutos[x] = {
              ...listaProdutos[x],

              nfi_ncm: listaProdutos[x].nfi_ncm,
              nfi_cfop: { key: listaProdutos[x].nfi_cfop ? String(listaProdutos[x].nfi_cfop) : response.data.pnfet_cfop ? String(response.data.pnfet_cfop) : '5102' },
              nficms_origem: { key: listaProdutos[x].nficms_origem ? String(listaProdutos[x].nficms_origem) : response.data.pnfet_origem_produto ? String(response.data.pnfet_origem_produto) : '0' },
              nficms_modbc: { key: listaProdutos[x].nficms_modbc ? String(listaProdutos[x].nficms_modbc) : '0' },

              nficms_cst: { key: listaProdutos[x].nficms_cst ? String(listaProdutos[x].nficms_cst).padStart(3, '0') : response.data.pnfet_cst_icms ? String(response.data.pnfet_cst_icms) : '0' },
              nfipi_cst: { key: listaProdutos[x].nfipi_cst ? String(listaProdutos[x].nfipi_cst).padStart(2, '0') : response.data.pnfet_cst_ipi ? String(response.data.pnfet_cst_ipi).padStart(2, '0') : '0' },
              nfpis_cst: { key: listaProdutos[x].nfpis_cst ? String(listaProdutos[x].nfpis_cst).padStart(2, '0') : response.data.pnfet_cst_pis ? String(response.data.pnfet_cst_pis).padStart(2, '0') : '0' },
              nfcof_cst: { key: listaProdutos[x].nfcof_cst ? String(listaProdutos[x].nfcof_cst).padStart(2, '0') : response.data.pnfet_cst_cofins ? String(response.data.pnfet_cst_cofins).padStart(2, '0') : '0' },
              nfci_cst: { key: listaProdutos[x].nfci_cst ? String(listaProdutos[x].nfci_cst).padStart(3, '0') : response.data.pnfet_cst_ibs_cbs ? String(response.data.pnfet_cst_ibs_cbs).padStart(3, '0') : '0' },
              nfci_sit_trib_ibs_cbs: listaProdutos[x].nfci_sit_trib_ibs_cbs ? listaProdutos[x].nfci_sit_trib_ibs_cbs : response.data.pnfet_sit_trib_ibs_cbs ? String(response.data.pnfet_sit_trib_ibs_cbs) : '',
            }

          }
        }

        this.calculoTotalPedido(listaProdutos);

        this.setState({
          listaProdutos
        })

      }).catch(error => {
        console.error(error.response);
      })

    axios.get('/parametros/parametros_nfe_cfop')
      .then(response => {
        this.setState({
          listaParCFOP: response.data,
        })
      }).catch(error => {
        console.error(error.response);
      })
  };


  onOK = (registroNfe) => {
    const { registro, listaProdutos } = this.state;

    if ((!registro.nf_destinatario) || (registro.nf_destinatario.key === '0') || (registro.nf_destinatario.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Destinatário', });
      return;
    }
    if ((!registro.nf_tipo_mov_nf) || (registro.nf_tipo_mov_nf.key === '0') || (registro.nf_tipo_mov_nf.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Tipo da Nota Fiscal', });
      return;
    }
    if ((!registro.nf_emitente) || (registro.nf_emitente.key === '0') || (registro.nf_emitente.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Emissor', });
      return;
    }
    if ((!registro.nf_modelo) || (registro.nf_modelo.key === '0') || (registro.nf_modelo.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Modelo', });
      return;
    }
    if ((!registro.nf_tipo_documento) || (registro.nf_tipo_documento.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Tipo Documento', });
      return;
    }
    if ((!registro.nf_nat_oper) || (registro.nf_nat_oper.key === '0') || (registro.nf_nat_oper.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Natureza da Operação', });
      return;
    }
    if ((!registro.nf_tipo_atendimento) || (registro.nf_tipo_atendimento.key === '0') || (registro.nf_tipo_atendimento.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Tipo de Atendimento', });
      return;
    }
    if ((!registro.nf_consumidor_final) || (registro.nf_consumidor_final.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Consumidor Final', });
      return;
    }
    if ((!registro.nff_tipo) || (registro.nff_tipo.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Tipo de Frete', });
      return;
    }

    if ((!listaProdutos) || (listaProdutos.length === 0)) {
      Modal.warning({ title: 'Aviso!', content: 'Lista de produtos vazia' });
      return;
    }

    const reg = {
      nf_tipo: registro.nf_tipo,
      nf_idf: registro.nf_idf ? registro.nf_idf : 0,
      nf_numero: registro.nf_numero ? registro.nf_numero : 0,
      nf_serie: registro.nf_serie ? registro.nf_serie : 0,
      nf_emitente: registro.nf_emitente.key,
      nf_destinatario: registro.nf_destinatario.key,
      nf_tipo_mov_nf: registro.nf_tipo_mov_nf.key,
      nf_modelo: registro.nf_modelo.key,
      nf_tipo_documento: registro.nf_tipo_documento.key,
      nf_nat_oper: registro.nf_nat_oper.key,
      nf_tipo_atendimento: registro.nf_tipo_atendimento.key,
      nf_forma_pagamento: registro.nf_forma_pagamento.key,
      nf_finalidade_emissao: registro.nf_finalidade_emissao.key,
      nf_consumidor_final: registro.nf_consumidor_final.key,

      nf_vlr_produtos: registro.nf_vlr_produtos,
      nf_bc_icms: registro.nf_bc_icms,
      nf_vlr_icms: registro.nf_vlr_icms,
      nf_bc_icms_st: registro.nf_bc_icms_st,
      nf_vlr_icms_st: registro.nf_vlr_icms_st,
      nf_vlr_ipi: registro.nf_vlr_ipi,
      nf_vlr_pis: registro.nf_vlr_pis,
      nf_vlr_cofins: registro.nf_vlr_cofins,
      nf_vlr_outras_desp: registro.nf_vlr_outras_desp,
      nf_vlr_frete: registro.nf_vlr_frete,
      nf_vlr_seguro: registro.nf_vlr_seguro,
      nf_vlr_desconto: registro.nf_vlr_desconto,
      nf_vlr_total: registro.nf_vlr_total,

      nf_obs_interna: registro.nf_obs_interna ? registro.nf_obs_interna : '',
      nfinf_texto: registro.nfinf_texto ? registro.nfinf_texto : '',

      nff_tipo: registro.nff_tipo.key,
      nff_idf_transportadora: registro.nff_idf_transportadora && registro.nff_idf_transportadora.key ? registro.nff_idf_transportadora.key : 0,
      nff_qtde_vol: registro.nff_qtde_vol,
      nff_especie: registro.nff_especie,
      nff_marca: registro.nff_marca,
      nff_num_volumes: registro.nff_num_volumes,
      nff_peso_liquido: registro.nff_peso_liquido,
      nff_peso_bruto: registro.nff_peso_bruto,

      listaProdutos: listaProdutos,

      transmitir: true,
    };


    this.props.onSalvarEmissaoNfeClick(reg);
  };

  calculoTotalPedido = (listaProdutos) => {
    const { registro } = this.state;

    // console.log('calculoTotalPedido', listaProdutos)

    let vlrProdutos = 0;
    let vlrBCICMS = 0;
    let vlrICMS = 0;
    let vlrBCICMSST = 0;
    let vlrICMSST = 0;
    let vlrIPI = 0;
    let vlrPIS = 0;
    let vlrCOFINS = 0;
    let vlrDespesa = 0;
    let vlrFrete = 0;
    let vlrSeguro = 0;
    let vlrDesconto = 0;
    let vlrTotal = 0;

    for (var x in listaProdutos) {
      vlrProdutos = vlrProdutos +
        ((parseFloat(listaProdutos[x].nfi_qtde) * parseFloat(listaProdutos[x].nfi_vlr_unitario))
          - parseFloat(listaProdutos[x].nfi_vlr_desconto)
          + parseFloat(listaProdutos[x].nfi_vlr_despesas)
          + parseFloat(listaProdutos[x].nfi_vlr_frete)
          + parseFloat(listaProdutos[x].nfi_vlr_seguro)
        );

      vlrBCICMS = vlrBCICMS + parseFloat(listaProdutos[x].nficms_vbc);
      vlrICMS = vlrICMS + parseFloat(listaProdutos[x].nficms_vicms);
      vlrBCICMSST = vlrBCICMSST + parseFloat(listaProdutos[x].nficms_vbcst);
      vlrICMSST = vlrICMSST + parseFloat(listaProdutos[x].nficms_vicmsst);
      vlrIPI = vlrIPI + parseFloat(listaProdutos[x].nfipi_vipi);
      vlrPIS = vlrPIS + parseFloat(listaProdutos[x].nfpis_vpis);
      vlrCOFINS = vlrCOFINS + parseFloat(listaProdutos[x].nfcof_vcofinf);

      vlrDespesa = vlrDespesa + parseFloat(listaProdutos[x].nfi_vlr_despesas);
      vlrFrete = vlrFrete + parseFloat(listaProdutos[x].nfi_vlr_frete);
      vlrSeguro = vlrSeguro + parseFloat(listaProdutos[x].nfi_vlr_seguro);
      vlrDesconto = vlrDesconto + parseFloat(listaProdutos[x].nfi_vlr_desconto);

      vlrTotal = vlrTotal +
        ((parseFloat(listaProdutos[x].nfi_qtde) * parseFloat(listaProdutos[x].nfi_vlr_unitario))
          - parseFloat(listaProdutos[x].nfi_vlr_desconto)
          + parseFloat(listaProdutos[x].nfi_vlr_despesas)
          + parseFloat(listaProdutos[x].nfi_vlr_frete)
          + parseFloat(listaProdutos[x].nfi_vlr_seguro)
        )
        + parseFloat(listaProdutos[x].nficms_vicmsst)
        + parseFloat(listaProdutos[x].nfipi_vipi)
        ;

    };

    vlrProdutos = parseFloat(vlrProdutos.toFixed(2));
    vlrBCICMS = parseFloat(vlrBCICMS.toFixed(2));
    vlrICMS = parseFloat(vlrICMS.toFixed(2));
    vlrBCICMSST = parseFloat(vlrBCICMSST.toFixed(2));
    vlrICMSST = parseFloat(vlrICMSST.toFixed(2));
    vlrIPI = parseFloat(vlrIPI.toFixed(2));
    vlrPIS = parseFloat(vlrPIS.toFixed(2));
    vlrCOFINS = parseFloat(vlrCOFINS.toFixed(2));
    vlrDespesa = parseFloat(vlrDespesa.toFixed(2));
    vlrFrete = parseFloat(vlrFrete.toFixed(2));
    vlrSeguro = parseFloat(vlrSeguro.toFixed(2));
    vlrDesconto = parseFloat(vlrDesconto.toFixed(2));
    vlrTotal = parseFloat(vlrTotal.toFixed(2));

    registro.nf_vlr_produtos = vlrProdutos;
    registro.nf_bc_icms = vlrBCICMS;
    registro.nf_vlr_icms = vlrICMS;
    registro.nf_bc_icms_st = vlrBCICMSST;
    registro.nf_vlr_icms_st = vlrICMSST;
    registro.nf_vlr_ipi = vlrIPI;
    registro.nf_vlr_pis = vlrPIS;
    registro.nf_vlr_cofins = vlrCOFINS;
    registro.nf_vlr_outras_desp = vlrDespesa;
    registro.nf_vlr_frete = vlrFrete;
    registro.nf_vlr_seguro = vlrSeguro;
    registro.nf_vlr_desconto = vlrDesconto;
    registro.nf_vlr_total = vlrTotal;

    this.setState({
      registro,
    });
  }



  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registro } = this.state;
    registro[id] = value;
    this.setState({ [id]: value });

    // console.log('onChange', event.target)


    if (id === 'nfi_qtde') {
      registro.nfi_vlr_total = parseFloat(((value * (parseFloat(this.state.registro.nfi_vlr_unitario))) - (parseFloat(this.state.registro.nfi_vlr_desconto)) + (parseFloat(this.state.registro.nfi_vlr_despesas))).toFixed(2));
      this.setState({
        registro
      });
    } else if (id === 'nfi_vlr_unitario') {
      registro.nfi_vlr_total = parseFloat(((value * (parseFloat(this.state.registro.nfi_qtde))) - (parseFloat(this.state.registro.nfi_vlr_desconto)) + (parseFloat(this.state.registro.nfi_vlr_despesas))).toFixed(2));
      this.setState({
        registro
      });
    } else if (id === 'nfi_vlr_despesas') {
      registro.nfi_vlr_total = parseFloat((((parseFloat(this.state.registro.nfi_qtde)) * (parseFloat(this.state.registro.nfi_vlr_unitario))) - (parseFloat(this.state.registro.nfi_vlr_desconto)) + (value)).toFixed(2));
      this.setState({
        registro
      });
    } else if (id === 'nfi_perc_desconto') {
      const percDesc = value / 100;
      const vlrDesc = parseFloat((parseFloat(this.state.registro.nfi_vlr_unitario) * parseFloat(this.state.registro.nfi_qtde)) * percDesc);

      registro.nfi_vlr_desconto = vlrDesc;
      registro.nfi_vlr_total = parseFloat((((parseFloat(this.state.registro.nfi_qtde)) * (parseFloat(this.state.registro.nfi_vlr_unitario))) - (vlrDesc) + (parseFloat(this.state.registro.nfi_vlr_despesas))).toFixed(2));
      this.setState({
        registro
      });
    } else if (id === 'nfi_vlr_desconto') {
      registro.nfi_vlr_total = parseFloat((((parseFloat(this.state.registro.nfi_qtde)) * (parseFloat(this.state.registro.nfi_vlr_unitario))) - (value) + (parseFloat(this.state.registro.nfi_vlr_despesas))).toFixed(2));
      this.setState({
        registro
      });
    }




    if (id === 'nficms_vbc') {
      registro.nficms_vicms = parseFloat((value * (parseFloat(this.state.nficms_picms) / 100)).toFixed(2));
      this.setState({
        registro
      });
    } else if (id === 'nficms_picms') {
      registro.nficms_vicms = parseFloat((parseFloat(this.state.nficms_vbc) * (value / 100)).toFixed(2));
      this.setState({
        registro
      });
    } else if (id === 'nficms_vbcst') {
      registro.nficms_vicmsst = parseFloat((value * (parseFloat(this.state.nficms_picmsst) / 100)).toFixed(2));
      this.setState({
        registro
      });
    } else if (id === 'nficms_picmsst') {
      registro.nficms_vicmsst = parseFloat((parseFloat(this.state.nficms_vbcst) * (value / 100)).toFixed(2));
      this.setState({
        registro
      });
    } else if (id === 'nfipi_vbc') {
      registro.nfipi_vipi = parseFloat((value * (parseFloat(this.state.nfipi_pipi) / 100)).toFixed(2));
      this.setState({
        registro
      });
    } else if (id === 'nfipi_pipi') {
      registro.nfipi_vipi = parseFloat((parseFloat(this.state.nfipi_vbc) * (value / 100)).toFixed(2));
      this.setState({
        registro
      });
    } else if (id === 'nfpis_vbc') {
      registro.nfpis_vpis = parseFloat((value * (parseFloat(this.state.nfpis_ppis) / 100)).toFixed(2));
      this.setState({
        registro
      });
    } else if (id === 'nfpis_ppis') {
      registro.nfpis_vpis = parseFloat((parseFloat(this.state.nfpis_vbc) * (value / 100)).toFixed(2));
      this.setState({
        registro
      });
    } else if (id === 'nfcof_vbc') {
      registro.nfcof_vcofinf = parseFloat((value * (parseFloat(this.state.nfcof_pcofins) / 100)).toFixed(2));
      this.setState({
        registro
      });
    } else if (id === 'nfcof_pcofins') {
      registro.nfcof_vcofinf = parseFloat((parseFloat(this.state.nfcof_vbc) * (value / 100)).toFixed(2));
      this.setState({
        registro
      });

    } else if (id === 'nfci_bc') {
      registro.nfci_vibs_mun = parseFloat((value * (parseFloat(this.state.nfci_pibs_mun) / 100)).toFixed(2));
      registro.nfci_vibs_est = parseFloat((value * (parseFloat(this.state.nfci_pibs_est) / 100)).toFixed(2));
      registro.nfci_vcbs = parseFloat((value * (parseFloat(this.state.nfci_pcbs) / 100)).toFixed(2));
      this.setState({
        registro
      });
    } else if (id === 'nfci_pibs_mun') {
      registro.nfci_vibs_mun = parseFloat((parseFloat(this.state.nfci_bc) * (value / 100)).toFixed(2));
      this.setState({
        registro
      });
    } else if (id === 'nfci_pibs_est') {
      registro.nfci_vibs_est = parseFloat((parseFloat(this.state.nfci_bc) * (value / 100)).toFixed(2));
      this.setState({
        registro
      });
    } else if (id === 'nfci_pcbs') {
      registro.nfci_vcbs = parseFloat((parseFloat(this.state.nfci_bc) * (value / 100)).toFixed(2));
      this.setState({
        registro
      });
    }
  };



  onChangeTransportador = event => {
    const { registro } = this.state;
    registro['nff_idf_transportadora'] = event.nff_idf_transportadora;
    this.setState(event);
  }

  onChangePessoa = event => {
    const { registro } = this.state;
    registro['ven_pessoa'] = event.ven_pessoa;
    this.setState(event);
  }

  onChangeVendedor = event => {
    const { registro } = this.state;
    registro['ven_usuario'] = event.ven_usuario;
    this.setState(event);
  }

  onDateChange = event => {
    // console.log('onDateChange', moment(event, 'YYYY-MM-DD').format('DD/MM/YYYY'));
    const { registro } = this.state;
    registro['ven_dt_venda'] = String(moment(event, 'YYYY-MM-DD').format('DD/MM/YYYY'));
    this.setState({ ven_dt_venda: String(moment(event, 'YYYY-MM-DD').format('DD/MM/YYYY')) });
  }



  // ----------------------------------------------------------------
  // PRODUTOS
  // ----------------------------------------------------------------

  onVoltarProdutosClick = () => {
    this.setState({
      editandoItem: false,
    });
  }

  onSalvarImpostosClick = () => {
    const { registro, listaProdutos } = this.state;

    if (!registro.nfi_ncm) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o NCM', });
      return;
    }
    if ((!registro.nfi_cfop) || (registro.nfi_cfop.key === '0') || (registro.nfi_cfop.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o CFOP', });
      return;
    }
    if ((!registro.nficms_origem) || (registro.nficms_origem.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Origem', });
      return;
    }
    if ((!registro.nficms_modbc) || (registro.nficms_modbc.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Modalidade', });
      return;
    }
    if ((!registro.nficms_cst) || (registro.nficms_cst.key === '0') || (registro.nficms_cst.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o CST ICMS', });
      return;
    }
    if ((!registro.nfipi_cst) || (registro.nfipi_cst.key === '0') || (registro.nfipi_cst.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o CST IPI', });
      return;
    }
    if ((!registro.nfipi_cst) || (registro.nfipi_cst.key === '0') || (registro.nfipi_cst.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o CST PIS', });
      return;
    }
    if ((!registro.nfcof_cst) || (registro.nfcof_cst.key === '0') || (registro.nfcof_cst.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o CST COFINS', });
      return;
    }
    if ((!registro.nfci_cst) || (registro.nfci_cst.key === '0') || (registro.nfci_cst.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o CST IBS/CBS', });
      return;
    }
    if ((!registro.nfci_sit_trib_ibs_cbs) || (registro.nfci_sit_trib_ibs_cbs === '0') || (registro.nfci_sit_trib_ibs_cbs === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Situação Tributárias do IBS/CBS', });
      return;
    }


    let iIndItem = -1;
    if (registro.nfi_seq >= 0) {
      for (var x in listaProdutos) {
        if (String(listaProdutos[x].nfi_seq) === String(registro.nfi_seq)) {
          iIndItem = x;
        }
      }
    }

    if (parseInt(iIndItem) >= 0) {
      listaProdutos[iIndItem] = {
        ...listaProdutos[iIndItem],

        nfi_ncm: registro.nfi_ncm,
        nfi_cfop: { key: String(registro.nfi_cfop.key) },
        nficms_origem: { key: String(registro.nficms_origem.key) },
        nficms_modbc: { key: String(registro.nficms_modbc.key) },

        nficms_cst: { key: String(registro.nficms_cst.key) },
        nficms_vbc: registro.nficms_vbc,
        nficms_picms: registro.nficms_picms,
        nficms_vicms: registro.nficms_vicms,

        nficms_vbcst: registro.nficms_vbcst,
        nficms_picmsst: registro.nficms_picmsst,
        nficms_vicmsst: registro.nficms_vicmsst,

        nfipi_cst: { key: String(registro.nfipi_cst.key) },
        nfipi_vbc: registro.nfipi_vbc,
        nfipi_pipi: registro.nfipi_pipi,
        nfipi_vipi: registro.nfipi_vipi,

        nfpis_cst: { key: String(registro.nfpis_cst.key) },
        nfpis_vbc: registro.nfpis_vbc,
        nfpis_ppis: registro.nfpis_ppis,
        nfpis_vpis: registro.nfpis_vpis,

        nfcof_cst: { key: String(registro.nfcof_cst.key) },
        nfcof_vbc: registro.nfcof_vbc,
        nfcof_pcofins: registro.nfcof_pcofins,
        nfcof_vcofinf: registro.nfcof_vcofinf,

        nfci_cst: registro.nfci_cst.key,
        nfci_sit_trib_ibs_cbs: registro.nfci_sit_trib_ibs_cbs,
        nfci_bc: registro.nfci_bc,
        nfci_pibs_mun: registro.nfci_pibs_mun,
        nfci_vibs_mun: registro.nfci_vibs_mun,
        nfci_pibs_est: registro.nfci_pibs_est,
        nfci_vibs_est: registro.nfci_vibs_est,
        nfci_pcbs: registro.nfci_pcbs,
        nfci_vcbs: registro.nfci_vcbs,
      };

      this.calculoTotalPedido(listaProdutos);

      this.setState({
        editandoItem: false,
        listaProdutos,
      });
    }
  }

  onEditarImpostosClick = (reg) => {
    this.setState({
      editandoItem: true,

      registro: {
        ...this.state.registro,
        nfi_seq: reg.nfi_seq,

        nfi_produto: (reg.prod_grade ? (reg.nfi_descricao_produto + ' - ' + reg.ptam_descricao + ' - ' + reg.pcor_descricao) : reg.nfi_descricao_produto) + ' [' + reg.nfi_prduto_codigo + ']',

        nfi_prduto_codigo: reg.nfi_prduto_codigo,
        nfi_descricao_produto: reg.nfi_descricao_produto,
        nfi_ncm: reg.nfi_ncm,
        nfi_cfop: reg.nfi_cfop,

        nficms_origem: reg.nficms_origem,
        nficms_modbc: reg.nficms_modbc,

        nficms_cst: reg.nficms_cst,
        nficms_vbc: reg.nficms_vbc,
        nficms_picms: reg.nficms_picms,
        nficms_vicms: reg.nficms_vicms,

        nficms_vbcst: reg.nficms_vbcst,
        nficms_picmsst: reg.nficms_picmsst,
        nficms_vicmsst: reg.nficms_vicmsst,

        nfipi_cst: reg.nfipi_cst,
        nfipi_vbc: reg.nfipi_vbc,
        nfipi_pipi: reg.nfipi_pipi,
        nfipi_vipi: reg.nfipi_vipi,

        nfpis_cst: reg.nfpis_cst,
        nfpis_vbc: reg.nfpis_vbc,
        nfpis_ppis: reg.nfpis_ppis,
        nfpis_vpis: reg.nfpis_vpis,

        nfcof_cst: reg.nfcof_cst,
        nfcof_vbc: reg.nfcof_vbc,
        nfcof_pcofins: reg.nfcof_pcofins,
        nfcof_vcofinf: reg.nfcof_vcofinf,

        nfci_cst: reg.nfci_cst,
        nfci_sit_trib_ibs_cbs: reg.nfci_sit_trib_ibs_cbs,
        nfci_bc: reg.nfci_bc,
        nfci_pibs_mun: reg.nfci_pibs_mun,
        nfci_vibs_mun: reg.nfci_vibs_mun,
        nfci_pibs_est: reg.nfci_pibs_est,
        nfci_vibs_est: reg.nfci_vibs_est,
        nfci_pcbs: reg.nfci_pcbs,
        nfci_vcbs: reg.nfci_vcbs,
      }
    });
  }





  renderValor = (ven_vlr_total, registro) => {
    return (
      <span> {numeral(parseFloat(ven_vlr_total)).format('0,000.00')} </span>
    );
  };

  renderDescrProduto = (prod_descricao, registro) => {
    return (
      <span> {!registro.prod_grade ? prod_descricao : registro.prod_descricao + ' - ' + registro.ptam_descricao + ' - ' + registro.pcor_descricao} </span>
    );
  };

  renderDescrCFOP = (nfi_cfop, registro) => {
    return (
      <span> {nfi_cfop.key} </span>
    );
  };

  renderDescrCSTICMS = (nficms_cst, registro) => {
    return (
      <span> {nficms_cst.key} </span>
    );
  };


  renderAcoesProdutos = (registro) => {
    return (
      <ButtonGroup size="small">
        <Tooltip title="Editar">
          <Button type="primary" onClick={() => this.onEditarImpostosClick(registro)} icon="edit" />
        </Tooltip>
      </ButtonGroup>
    );
  };


  renderData = (data) => {
    if (data) {
      const dataMoment = moment(data);
      return (
        <span>
          {dataMoment.format('DD/MM/YYYY')}
        </span>
      )
    } else {
      <span></span>
    }
  }

  onChangeTipoDoc = event => {
    const { registro } = this.state;
    registro['ven_tipo_doc'] = event.ven_tipo_doc;
    this.state.listaParcelas = [];
    this.setState(event);
  }

  onChangeCondPagto = event => {
    const { registro } = this.state;
    registro['ven_cond_pagto'] = event.ven_cond_pagto;
    this.state.listaParcelas = [];
    this.setState(event);
  }


  // ----------------------------------------------------------------





  onChangeTabs = (activeKey) => {
    this.setState({ activeKey });
  }

  onCadPessoaClick = () => {
    this.setState({
      modalListaVisible: true,
      tipoPessoa: 'clientes'
    });
  }

  onCadTranspClick = () => {
    this.setState({
      modalListaVisible: true,
      tipoPessoa: 'transportadoras'
    });
  }

  onFecharModalLista = () => {
    this.setState({
      modalListaVisible: false,
    });
  }







  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------



  render() {
    const { onFecharModalEmissaoNFeClick, carregando, visivel } = this.props;

    const { usuario, carregandoForm, visualizando, listaProdutos, produtoSelecionado,
      OPCOES_COMBO_EMITENTE, OPCOES_COMBO_TIPO_MOV_NF, OPCOES_COMBO_CFOP, OPCOES_COMBO_MODELO,
      editandoItem, caixaFechado, modalListaVisible, modalProdutoVisible, tipoPessoa } = this.state;


    const { nf_idf, nf_numero, nf_serie, nf_status, situacao_nota, nf_tipo_mov_nf, nf_destinatario, nf_obs_interna, nf_dt_emissao, nf_dt_inclusao, nf_chave, nf_tipo_doc, nfinf_texto,
      nf_cond_pagto, nff_tipo, nff_idf_transportadora, nff_num_volumes, nff_especie, nff_marca, nff_qtde_vol, nff_peso_bruto, nff_peso_liquido, nf_chave_rel,
      nf_emitente, nf_modelo, nf_nat_oper, nf_forma_pagamento, nf_finalidade_emissao, nf_consumidor_final, nf_tipo_documento, nf_tipo_atendimento,
      nf_vlr_total, nf_vlr_cofins, nf_vlr_desconto, nf_vlr_frete, nf_vlr_icms, nf_vlr_icms_st, nf_vlr_ipi, nf_vlr_outras_desp, nf_vlr_pis, nf_vlr_produtos, nf_vlr_seguro, nf_bc_icms, nf_bc_icms_st,
      nfi_produto, nfi_ncm, nficms_origem, nfi_cfop, nficms_modbc, nficms_cst, nficms_vbc, nficms_picms, nficms_vicms, nficms_vbcst, nficms_picmsst, nficms_vicmsst,
      nfipi_cst, nfipi_vbc, nfipi_pipi, nfipi_vipi, nfpis_cst, nfpis_vbc, nfpis_ppis, nfpis_vpis, nfcof_cst, nfcof_vbc, nfcof_pcofins, nfcof_vcofinf,
      nfci_cst, nfci_sit_trib_ibs_cbs, nfci_bc, nfci_pibs_mun, nfci_vibs_mun, nfci_pibs_est, nfci_vibs_est, nfci_pcbs, nfci_vcbs
    } = this.state.registro;

    // console.log('NotaFiscalEmissaoComplForm.this.state: ', this.state);

    return (
      <Modal
        title="Emissão da Nota Fiscal"
        visible={visivel}
        destroyOnClose
        onCancel={onFecharModalEmissaoNFeClick}
        footer={null}
        width={"55%"}
        style={{ top: 20 }}
      >



        <ModalPadraoForm
          visivel={modalListaVisible}
          telaModal={tipoPessoa}
          valorTotal={0}
          onFecharClick={this.onFecharModalLista}
        />



        <div>
          <Tabs
            type="card"
            activeKey={this.state.activeKey}
            onChange={this.onChangeTabs}
          >
            <TabPane tab="Dados da Nota" key="dados">
              <div style={{ height: 300 }}>

                <Row>
                  <Col xs={24} sm={4} className="camposEspacoDireita">
                    <span>Numero</span>
                    <InputForm
                      id="nf_numero"
                      ref="nf_numero"
                      maxLength={9}
                      onChange={this.onChange}
                      value={nf_numero}
                      readOnly
                    />
                  </Col>
                  <Col xs={24} sm={4} className="camposEspacoDireita">
                    <span>Série</span>
                    <InputForm
                      id="nf_serie"
                      ref="nf_serie"
                      maxLength={9}
                      onChange={this.onChange}
                      value={nf_serie}
                      readOnly
                    />
                  </Col>
                  <Col xs={24} sm={4} className="camposEspacoDireita">
                    <span>Situação</span>
                    <InputForm
                      id="situacao_nota"
                      ref="situacao_nota"
                      maxLength={20}
                      onChange={this.onChange}
                      value={situacao_nota}
                      readOnly
                    />
                  </Col>
                  <Col xs={24} sm={12}>
                    <span>Tipo Nota Fiscal</span>
                    <InputForm
                      type="select"
                      id="nf_tipo_mov_nf"
                      ref="nf_tipo_mov_nf"
                      value={nf_tipo_mov_nf}
                      placeholder="Selecione o Tipo"
                      onChange={this.onChange}
                      data={OPCOES_COMBO_TIPO_MOV_NF}
                      validator={value => Boolean(value)}
                      style={{ width: "100%" }}
                    />
                  </Col>

                  <Col xs={24} sm={11} style={{ marginTop: -20 }}>
                    <PessoaFrame
                      label="Remetente/Destinatário"
                      id="nf_destinatario"
                      value={nf_destinatario}
                      tipo="C"
                      width={"100%"}
                      onChange={this.onChangePessoa}
                      readOnly={true}
                      descricaoPrimeiroItem="Destinatário"
                    />
                  </Col>
                  <Col xs={24} sm={1} style={{ marginTop: 4, paddingRight: 20 }}>
                    <Tooltip title="Cadastro de Clientes" placement="topLeft">
                      <Button
                        type="dashed"
                        icon="plus"
                        htmlType="button"
                        onClick={() => this.onCadPessoaClick()}
                        disabled={visualizando}
                      />
                    </Tooltip>
                  </Col>
                  <Col xs={24} sm={12} style={{ marginTop: -20 }} >
                    <span>OBS Interna</span>
                    <InputForm
                      id="nf_obs_interna"
                      ref="nf_obs_interna"
                      maxLength={200}
                      onChange={this.onChange}
                      value={nf_obs_interna}
                    />
                  </Col>
                  <Col xs={24} sm={6} style={{ marginTop: -20 }} className="camposEspacoDireita">
                    <span>Data Emissão</span>
                    <InputForm
                      id="nf_dt_emissao"
                      ref="nf_dt_emissao"
                      value={nf_dt_emissao}
                      readOnly
                    />
                  </Col>
                  <Col xs={24} sm={6} style={{ marginTop: -20 }} className="camposEspacoDireita">
                    <span>Data Ent/Sai</span>
                    <InputForm
                      id="nf_dt_inclusao"
                      ref="nf_dt_inclusao"
                      value={nf_dt_inclusao}
                      readOnly
                    />
                  </Col>
                  <Col xs={24} sm={12} style={{ marginTop: -20 }}  >
                    <span>Chave</span>
                    <InputForm
                      id="nf_chave"
                      ref="nf_chave"
                      maxLength={9}
                      onChange={this.onChange}
                      value={nf_chave}
                      readOnly
                    />
                  </Col>

                  <Col xs={24} sm={9} className="camposEspacoDireita">
                    <span>Emissor</span>
                    <InputForm
                      type="select"
                      id="nf_emitente"
                      ref="nf_emitente"
                      value={nf_emitente}
                      placeholder="Selecione o Tipo"
                      onChange={this.onChangeEmitente}
                      data={OPCOES_COMBO_EMITENTE}
                      validator={value => Boolean(value)}
                      style={{ width: "100%" }}
                      showSearch
                    />
                  </Col>
                  <Col xs={24} sm={9} className="camposEspacoDireita">
                    <span>Modelo</span>
                    <InputForm
                      type="select"
                      id="nf_modelo"
                      ref="nf_modelo"
                      value={nf_modelo}
                      placeholder="Selecione o Tipo"
                      onChange={this.onChange}
                      data={OPCOES_COMBO_MODELO}
                      validator={value => Boolean(value)}
                      style={{ width: "100%" }}
                      showSearch
                    />
                  </Col>
                  <Col xs={24} sm={6} style={{}} className="camposEspacoDireita">
                    <span>Tipo Documento</span>
                    <InputForm
                      type="select"
                      id="nf_tipo_documento"
                      ref="nf_tipo_documento"
                      value={nf_tipo_documento}
                      placeholder="Selecione o Tipo"
                      onChange={this.onChange}
                      data={OPCOES_COMBO_TIPO_DOC}
                      validator={value => Boolean(value)}
                      style={{ width: "100%" }}
                    />
                  </Col>
                  <Col xs={24} sm={16} style={{ marginTop: -20 }} className="camposEspacoDireita">
                    <span>Natureza da Operação</span>
                    <InputForm
                      type="select"
                      id="nf_nat_oper"
                      ref="nf_nat_oper"
                      value={nf_nat_oper}
                      placeholder="Selecione o Tipo"
                      onChange={this.onChange}
                      data={OPCOES_COMBO_CFOP}
                      validator={value => Boolean(value)}
                      style={{ width: "100%" }}
                      showSearch
                    />
                  </Col>
                  <Col xs={24} sm={8} style={{ marginTop: -20 }} >
                    <span>Tipo Atendimento</span>
                    <InputForm
                      type="select"
                      id="nf_tipo_atendimento"
                      ref="nf_tipo_atendimento"
                      value={nf_tipo_atendimento}
                      placeholder="Selecione o Tipo"
                      onChange={this.onChange}
                      data={OPCOES_COMBO_TIPO_ATENDIMENTO}
                      validator={value => Boolean(value)}
                      style={{ width: "100%" }}
                    />
                  </Col>
                  <Col xs={24} sm={4} style={{ marginTop: -20 }} className="camposEspacoDireita">
                    <span>Forma Pagto</span>
                    <InputForm
                      type="select"
                      id="nf_forma_pagamento"
                      ref="nf_forma_pagamento"
                      value={nf_forma_pagamento}
                      placeholder="Selecione o Tipo"
                      onChange={this.onChange}
                      data={OPCOES_COMBO_FORMA_PAGTO}
                      validator={value => Boolean(value)}
                      style={{ width: "100%" }}
                    />
                  </Col>
                  <Col xs={24} sm={4} style={{ marginTop: -20 }} className="camposEspacoDireita">
                    <span>Finalidade Emissão</span>
                    <InputForm
                      type="select"
                      id="nf_finalidade_emissao"
                      ref="nf_finalidade_emissao"
                      value={nf_finalidade_emissao}
                      placeholder="Selecione o Tipo"
                      onChange={this.onChange}
                      data={OPCOES_COMBO_FINALIDADE_EMISSAO}
                      validator={value => Boolean(value)}
                      style={{ width: "100%" }}
                    />
                  </Col>
                  <Col xs={24} sm={4} style={{ marginTop: -20 }} className="camposEspacoDireita">
                    <span>Consum. Final</span>
                    <InputForm
                      type="select"
                      id="nf_consumidor_final"
                      ref="nf_consumidor_final"
                      value={nf_consumidor_final}
                      placeholder="Selecione o Tipo"
                      onChange={this.onChange}
                      data={OPCOES_COMBO_CONS_FINAL}
                      validator={value => Boolean(value)}
                      style={{ width: "100%" }}
                    />
                  </Col>

                </Row>

                <div className="divider-lg-form" />

                <Row>
                  <Col xs={24} sm={3} style={{ marginTop: 4, paddingRight: 20 }}>
                    <span>Valor Produtos</span>
                    <InputForm
                      type="number"
                      id="nf_vlr_produtos"
                      ref="nf_vlr_produtos"
                      value={nf_vlr_produtos}
                      onChange={this.onChange}
                      disabled={true}
                    />
                  </Col>
                  <Col xs={24} sm={3} style={{ marginTop: 4, paddingRight: 20 }}>
                    <span>BC ICMS</span>
                    <InputForm
                      type="number"
                      id="nf_bc_icms"
                      ref="nf_bc_icms"
                      value={nf_bc_icms}
                      onChange={this.onChange}
                      disabled={true}
                    />
                  </Col>
                  <Col xs={24} sm={3} style={{ marginTop: 4, paddingRight: 20 }}>
                    <span>Valor ICMS</span>
                    <InputForm
                      type="number"
                      id="nf_vlr_icms"
                      ref="nf_vlr_icms"
                      value={nf_vlr_icms}
                      onChange={this.onChange}
                      disabled={true}
                    />
                  </Col>
                  <Col xs={24} sm={3} style={{ marginTop: 4, paddingRight: 20 }}>
                    <span>BC ICMS Subst</span>
                    <InputForm
                      type="number"
                      id="nf_bc_icms_st"
                      ref="nf_bc_icms_st"
                      value={nf_bc_icms_st}
                      onChange={this.onChange}
                      disabled={true}
                    />
                  </Col>
                  <Col xs={24} sm={3} style={{ marginTop: 4, paddingRight: 20 }}>
                    <span>Vlr ICMS Subst</span>
                    <InputForm
                      type="number"
                      id="nf_vlr_icms_st"
                      ref="nf_vlr_icms_st"
                      value={nf_vlr_icms_st}
                      onChange={this.onChange}
                      disabled={true}
                    />
                  </Col>
                  <Col xs={24} sm={3} style={{ marginTop: 4, paddingRight: 20 }}>
                    <span>Valor IPI</span>
                    <InputForm
                      type="number"
                      id="nf_vlr_ipi"
                      ref="nf_vlr_ipi"
                      value={nf_vlr_ipi}
                      onChange={this.onChange}
                      disabled={true}
                    />
                  </Col>

                  <Col xs={24} sm={3} style={{ marginTop: 4, paddingRight: 20 }}>
                    <span>Valor PIS</span>
                    <InputForm
                      type="number"
                      id="nf_vlr_pis"
                      ref="nf_vlr_pis"
                      value={nf_vlr_pis}
                      onChange={this.onChange}
                      disabled={true}
                    />
                  </Col>
                  <Col xs={24} sm={3} style={{ marginTop: 4, paddingRight: 20 }}>
                    <span>Valor COFINS</span>
                    <InputForm
                      type="number"
                      id="nf_vlr_cofins"
                      ref="nf_vlr_cofins"
                      value={nf_vlr_cofins}
                      onChange={this.onChange}
                      disabled={true}
                    />
                  </Col>
                  <Col xs={24} sm={3} style={{ marginTop: -20, paddingRight: 20 }}>
                    <span>Outras Desp</span>
                    <InputForm
                      type="number"
                      id="nf_vlr_outras_desp"
                      ref="nf_vlr_outras_desp"
                      value={nf_vlr_outras_desp}
                      onChange={this.onChange}
                      disabled={true}
                    />
                  </Col>
                  <Col xs={24} sm={3} style={{ marginTop: -20, paddingRight: 20 }}>
                    <span>Valor Frete</span>
                    <InputForm
                      type="number"
                      id="nf_vlr_frete"
                      ref="nf_vlr_frete"
                      value={nf_vlr_frete}
                      onChange={this.onChange}
                      disabled={true}
                    />
                  </Col>
                  <Col xs={24} sm={3} style={{ marginTop: -20, paddingRight: 20 }}>
                    <span>Valor Seguro</span>
                    <InputForm
                      type="number"
                      id="nf_vlr_seguro"
                      ref="nf_vlr_seguro"
                      value={nf_vlr_seguro}
                      onChange={this.onChange}
                      disabled={true}
                    />
                  </Col>
                  <Col xs={24} sm={3} style={{ marginTop: -20, paddingRight: 20 }}>
                    <span>Valor Desconto</span>
                    <InputForm
                      type="number"
                      id="nf_vlr_desconto"
                      ref="nf_vlr_desconto"
                      value={nf_vlr_desconto}
                      onChange={this.onChange}
                      disabled={true}
                    />
                  </Col>
                  <Col xs={24} sm={3} style={{ marginTop: -20, paddingRight: 20 }}>
                    <span>Total Nota</span>
                    <InputForm
                      type="number"
                      id="nf_vlr_total"
                      ref="nf_vlr_total"
                      value={nf_vlr_total}
                      onChange={this.onChange}
                      disabled={true}
                    />
                  </Col>
                </Row>
              </div>
            </TabPane>

            <TabPane tab="Itens da Nota" key="produtos">
              {editandoItem ? null : (
                <div style={{ height: 300 }}>
                  <Table
                    loading={{
                      spinning: carregandoForm,
                      tip: 'Carregando. Aguarde...',
                      size: "large"
                    }}
                    dataSource={listaProdutos}
                    pagination={false}
                    rowKey={(listaProdutos => listaProdutos.mi_item + '_' + listaProdutos.mi_item_tamanho + '_' + listaProdutos.mi_item_cor)}
                  >
                    <Column
                      key="nfi_prduto_codigo"
                      dataIndex="nfi_prduto_codigo"
                      title="Código"
                      width={60}
                      align="center"
                      className="listaCadastro"
                    />
                    <Column
                      key="nfi_descricao_produto"
                      dataIndex="nfi_descricao_produto"
                      title="Descrição"
                      width={200}
                      align="left"
                      className="listaCadastro"
                      render={this.renderDescrProduto}
                    />
                    <Column
                      key="nfi_ncm"
                      dataIndex="nfi_ncm"
                      title="NCM"
                      width={60}
                      align="center"
                      className="listaCadastro"
                    />
                    <Column
                      key="nfi_cfop"
                      dataIndex="nfi_cfop"
                      title="CFOP"
                      width={60}
                      align="center"
                      className="listaCadastro"
                      render={this.renderDescrCFOP}
                    />
                    <Column
                      key="nficms_cst"
                      dataIndex="nficms_cst"
                      title="CST ICMS"
                      width={60}
                      align="center"
                      className="listaCadastro"
                      render={this.renderDescrCSTICMS}
                    />
                    <Column
                      key="nficms_vbc"
                      dataIndex="nficms_vbc"
                      title="BC ICMS"
                      render={this.renderValor}
                      width={60}
                      align="right"
                      className="listaCadastro"
                    />
                    <Column
                      key="nficms_picms"
                      dataIndex="nficms_picms"
                      title="% ICMS"
                      render={this.renderValor}
                      width={60}
                      align="right"
                      className="listaCadastro"
                    />
                    <Column
                      key="nficms_vicms"
                      dataIndex="nficms_vicms"
                      title="Vlr ICMS"
                      render={this.renderValor}
                      width={60}
                      align="right"
                      className="listaCadastro"
                    />
                    {this.state.visualizando || caixaFechado ? null : (
                      <Column
                        key="acoes"
                        title=""
                        render={this.renderAcoesProdutos}
                        width={70}
                        align="center"
                        className="listaCadastro"
                      />
                    )}
                  </Table>
                </div>
              )}

              {editandoItem ? (
                <Row style={{ marginTop: 20 }}>
                  <Row>
                    <Col xs={3} style={{}}>
                      <Button
                        htmlType="button"
                        onClick={this.onVoltarProdutosClick}
                      >
                        {'<< Voltar'}
                      </Button>
                    </Col>
                    <Col xs={4} style={{}}>
                      {this.state.visualizar || caixaFechado ? null : (
                        <Button
                          type="primary"
                          htmlType="button"
                          loading={carregando}
                          onClick={this.onSalvarImpostosClick}
                        >
                          Salvar Impostos
                        </Button>
                      )}
                    </Col>
                    <Col xs={12} style={{ marginTop: 5, marginLeft: 30 }}>
                      <span style={{ fontSize: 20, fontWeight: 'bold' }}>Editando Impostos</span>
                    </Col>
                  </Row>

                  <Col xs={24} sm={20} style={{ marginTop: 20, paddingRight: 10 }}  >
                    <span>Produto</span>
                    <InputForm
                      id="nfi_produto"
                      ref="nfi_produto"
                      onChange={this.onChange}
                      value={nfi_produto}
                      readOnly
                    />
                  </Col>
                  <Col xs={24} sm={4} style={{ marginTop: 20 }} >
                    <span>NCM</span>
                    <InputForm
                      id="nfi_ncm"
                      ref="nfi_ncm"
                      maxLength={9}
                      onChange={this.onChange}
                      value={nfi_ncm}
                    />
                  </Col>
                  <Col xs={24} sm={24} style={{ marginTop: -20 }}>
                    <span>CFOP</span>
                    <InputForm
                      type="select"
                      id="nfi_cfop"
                      ref="nfi_cfop"
                      value={nfi_cfop}
                      placeholder="Selecione o CFOP"
                      onChange={this.onChange}
                      data={OPCOES_COMBO_CFOP}
                      validator={value => Boolean(value)}
                      style={{ width: "100%" }}
                      showSearch
                    />
                  </Col>
                  <Col xs={24} sm={24} style={{ marginTop: -20 }} >
                    <span>Origem</span>
                    <InputForm
                      type="select"
                      id="nficms_origem"
                      ref="nficms_origem"
                      value={nficms_origem}
                      placeholder="Selecione"
                      onChange={this.onChange}
                      data={OPCOES_COMBO_ORIGEM}
                      validator={value => Boolean(value)}
                      style={{ width: "100%" }}
                    />
                  </Col>

                  <Col xs={24} sm={24} style={{ marginTop: -20 }} >
                    <span>Modalidade</span>
                    <InputForm
                      type="select"
                      id="nficms_modbc"
                      ref="nficms_modbc"
                      value={nficms_modbc}
                      placeholder="Selecione"
                      onChange={this.onChange}
                      data={OPCOES_COMBO_MODALIDADE}
                      validator={value => Boolean(value)}
                      style={{ width: "100%" }}
                    />
                  </Col>


                  <Col xs={24} sm={24} style={{ marginTop: -10 }} >
                    <span>CST ICMS</span>
                    <InputForm
                      type="select"
                      id="nficms_cst"
                      ref="nficms_cst"
                      value={nficms_cst}
                      placeholder="Selecione"
                      onChange={this.onChange}
                      data={OPCOES_COMBO_CST_ICMS}
                      validator={value => Boolean(value)}
                      style={{ width: "100%" }}
                    />
                  </Col>
                  <Col xs={24} sm={8} style={{ marginTop: -20, paddingRight: 20 }}>
                    <span>BC ICMS</span>
                    <InputForm
                      type="number"
                      id="nficms_vbc"
                      ref="nficms_vbc"
                      value={nficms_vbc}
                      onChange={this.onChange}
                    />
                  </Col>
                  <Col xs={24} sm={8} style={{ marginTop: -20, paddingRight: 20 }}>
                    <span>Alíquita ICMS</span>
                    <InputForm
                      type="number"
                      id="nficms_picms"
                      ref="nficms_picms"
                      value={nficms_picms}
                      onChange={this.onChange}
                    />
                  </Col>
                  <Col xs={24} sm={8} style={{ marginTop: -20 }}>
                    <span>Valor ICMS</span>
                    <InputForm
                      type="number"
                      id="nficms_vicms"
                      ref="nficms_vicms"
                      value={nficms_vicms}
                      disabled={true}
                    />
                  </Col>

                  <Col xs={24} sm={8} style={{ marginTop: -20, paddingRight: 20 }}>
                    <span>BC ICMS ST</span>
                    <InputForm
                      type="number"
                      id="nficms_vbcst"
                      ref="nficms_vbcst"
                      value={nficms_vbcst}
                      onChange={this.onChange}
                    />
                  </Col>
                  <Col xs={24} sm={8} style={{ marginTop: -20, paddingRight: 20 }}>
                    <span>Alíquita ICMS ST</span>
                    <InputForm
                      type="number"
                      id="nficms_picmsst"
                      ref="nficms_picmsst"
                      value={nficms_picmsst}
                      onChange={this.onChange}
                    />
                  </Col>
                  <Col xs={24} sm={8} style={{ marginTop: -20 }}>
                    <span>Valor ICMS ST</span>
                    <InputForm
                      type="number"
                      id="nficms_vicmsst"
                      ref="nficms_vicmsst"
                      value={nficms_vicmsst}
                      disabled={true}
                    />
                  </Col>


                  <Col xs={24} sm={24} style={{ marginTop: -10 }} >
                    <span>CST IPI</span>
                    <InputForm
                      type="select"
                      id="nfipi_cst"
                      ref="nfipi_cst"
                      value={nfipi_cst}
                      placeholder="Selecione"
                      onChange={this.onChange}
                      data={OPCOES_COMBO_CST_IPI}
                      validator={value => Boolean(value)}
                      style={{ width: "100%" }}
                    />
                  </Col>
                  <Col xs={24} sm={8} style={{ marginTop: -20, paddingRight: 20 }}>
                    <span>BC IPI</span>
                    <InputForm
                      type="number"
                      id="nfipi_vbc"
                      ref="nfipi_vbc"
                      value={nfipi_vbc}
                      onChange={this.onChange}
                    />
                  </Col>
                  <Col xs={24} sm={8} style={{ marginTop: -20, paddingRight: 20 }}>
                    <span>Alíquita IPI</span>
                    <InputForm
                      type="number"
                      id="nfipi_pipi"
                      ref="nfipi_pipi"
                      value={nfipi_pipi}
                      onChange={this.onChange}
                    />
                  </Col>
                  <Col xs={24} sm={8} style={{ marginTop: -20 }}>
                    <span>Valor IPI</span>
                    <InputForm
                      type="number"
                      id="nfipi_vipi"
                      ref="nfipi_vipi"
                      value={nfipi_vipi}
                      disabled={true}
                    />
                  </Col>


                  <Col xs={24} sm={24} style={{ marginTop: -10 }} >
                    <span>CST PIS</span>
                    <InputForm
                      type="select"
                      id="nfpis_cst"
                      ref="nfpis_cst"
                      value={nfpis_cst}
                      placeholder="Selecione"
                      onChange={this.onChange}
                      data={OPCOES_COMBO_CST_PIS}
                      validator={value => Boolean(value)}
                      style={{ width: "100%" }}
                    />
                  </Col>
                  <Col xs={24} sm={8} style={{ marginTop: -20, paddingRight: 20 }}>
                    <span>BC PIS</span>
                    <InputForm
                      type="number"
                      id="nfpis_vbc"
                      ref="nfpis_vbc"
                      value={nfpis_vbc}
                      onChange={this.onChange}
                    />
                  </Col>
                  <Col xs={24} sm={8} style={{ marginTop: -20, paddingRight: 20 }}>
                    <span>Alíquita PIS</span>
                    <InputForm
                      type="number"
                      id="nfpis_ppis"
                      ref="nfpis_ppis"
                      value={nfpis_ppis}
                      onChange={this.onChange}
                    />
                  </Col>
                  <Col xs={24} sm={8} style={{ marginTop: -20 }}>
                    <span>Valor PIS</span>
                    <InputForm
                      type="number"
                      id="nfpis_vpis"
                      ref="nfpis_vpis"
                      value={nfpis_vpis}
                      disabled={true}
                    />
                  </Col>


                  <Col xs={24} sm={24} style={{ marginTop: -10 }} >
                    <span>CST COFINS</span>
                    <InputForm
                      type="select"
                      id="nfcof_cst"
                      ref="nfcof_cst"
                      value={nfcof_cst}
                      placeholder="Selecione"
                      onChange={this.onChange}
                      data={OPCOES_COMBO_CST_COFINS}
                      validator={value => Boolean(value)}
                      style={{ width: "100%" }}
                    />
                  </Col>
                  <Col xs={24} sm={8} style={{ marginTop: -20, paddingRight: 20 }}>
                    <span>BC COFINS</span>
                    <InputForm
                      type="number"
                      id="nfcof_vbc"
                      ref="nfcof_vbc"
                      value={nfcof_vbc}
                      onChange={this.onChange}
                    />
                  </Col>
                  <Col xs={24} sm={8} style={{ marginTop: -20, paddingRight: 20 }}>
                    <span>Alíquita COFINS</span>
                    <InputForm
                      type="number"
                      id="nfcof_pcofins"
                      ref="nfcof_pcofins"
                      value={nfcof_pcofins}
                      onChange={this.onChange}
                    />
                  </Col>
                  <Col xs={24} sm={8} style={{ marginTop: -20 }}>
                    <span>Valor COFINS</span>
                    <InputForm
                      type="number"
                      id="nfcof_vcofinf"
                      ref="nfcof_vcofinf"
                      value={nfcof_vcofinf}
                      disabled={true}
                    />
                  </Col>


                  <Col xs={24} sm={24} style={{ marginTop: -10 }} >
                    <span>CST IBS/CBS</span>
                    <InputForm
                      type="select"
                      id="nfci_cst"
                      ref="nfci_cst"
                      value={nfci_cst}
                      placeholder="Selecione"
                      onChange={this.onChange}
                      data={OPCOES_COMBO_CST_IBS_CBS}
                      validator={value => Boolean(value)}
                      style={{ width: "100%" }}
                    />
                  </Col>
                  <Col xs={24} sm={6} style={{ marginTop: -20, paddingRight: 20 }} >
                    <span>Situação Tributária</span>
                    <InputForm
                      id="nfci_sit_trib_ibs_cbs"
                      ref="nfci_sit_trib_ibs_cbs"
                      maxLength={9}
                      onChange={this.onChange}
                      value={nfci_sit_trib_ibs_cbs}
                    />
                  </Col>
                  <Col xs={24} sm={6} style={{ marginTop: -20, paddingRight: 20 }}>
                    <span>BC IBS/CBS</span>
                    <InputForm
                      type="number"
                      id="nfci_bc"
                      ref="nfci_bc"
                      value={nfci_bc}
                      onChange={this.onChange}
                    />
                  </Col>
                  <Col xs={24} sm={6} style={{ marginTop: -20, paddingRight: 20 }}>
                    <span>Alíquita IBS Mun.</span>
                    <InputForm
                      type="number"
                      id="nfci_pibs_mun"
                      ref="nfci_pibs_mun"
                      value={nfci_pibs_mun}
                      onChange={this.onChange}
                    />
                  </Col>
                  <Col xs={24} sm={6} style={{ marginTop: -20 }}>
                    <span>Valor IBS Mun.</span>
                    <InputForm
                      type="number"
                      id="nfci_vibs_mun"
                      ref="nfci_vibs_mun"
                      value={nfci_vibs_mun}
                      disabled={true}
                    />
                  </Col>
                  <Col xs={24} sm={6} style={{ marginTop: -20, paddingRight: 20 }}>
                    <span>Alíquita IBS Est.</span>
                    <InputForm
                      type="number"
                      id="nfci_pibs_est"
                      ref="nfci_pibs_est"
                      value={nfci_pibs_est}
                      onChange={this.onChange}
                    />
                  </Col>
                  <Col xs={24} sm={6} style={{ marginTop: -20, paddingRight: 20 }}>
                    <span>Valor IBS Est.</span>
                    <InputForm
                      type="number"
                      id="nfci_vibs_est"
                      ref="nfci_vibs_est"
                      value={nfci_vibs_est}
                      disabled={true}
                    />
                  </Col>
                  <Col xs={24} sm={6} style={{ marginTop: -20, paddingRight: 20 }}>
                    <span>Alíquita CBS</span>
                    <InputForm
                      type="number"
                      id="nfci_pcbs"
                      ref="nfci_pcbs"
                      value={nfci_pcbs}
                      onChange={this.onChange}
                    />
                  </Col>
                  <Col xs={24} sm={6} style={{ marginTop: -20 }}>
                    <span>Valor CBS</span>
                    <InputForm
                      type="number"
                      id="nfci_vcbs"
                      ref="nfci_vcbs"
                      value={nfci_vcbs}
                      disabled={true}
                    />
                  </Col>


                </Row>
              ) : null}
            </TabPane>

            <TabPane tab="Transporte" key="transporte">
              <div style={{ height: 300 }}>
                <Row>
                  <Col xs={24} sm={12} className="camposEspacoDireita">
                    <span>Frete por conta de</span>
                    <InputForm
                      type="select"
                      id="nff_tipo"
                      ref="nff_tipo"
                      value={nff_tipo}
                      placeholder="Selecione o Tipo"
                      onChange={this.onChange}
                      data={OPCOES_COMBO_TIPO_FRETE}
                      validator={value => Boolean(value)}
                      style={{ width: "100%" }}
                    />
                  </Col>
                  <Col xs={24} sm={11} style={{}}>
                    <PessoaFrame
                      label="Transportador"
                      id="nff_idf_transportadora"
                      value={nff_idf_transportadora}
                      tipo="T"
                      width={"100%"}
                      onChange={this.onChangeTransportador}
                      descricaoPrimeiroItem="Selecione um Transportador"
                    />
                  </Col>
                  <Col xs={24} sm={1} style={{ marginTop: 25 }}>
                    <Tooltip title="Cadastro de Transportadora" placement="topLeft">
                      <Button
                        type="dashed"
                        icon="plus"
                        htmlType="button"
                        onClick={() => this.onCadTranspClick()}
                        disabled={visualizando}
                      />
                    </Tooltip>
                  </Col>
                  <Col xs={24} sm={6} style={{ marginTop: -20, paddingRight: 20 }}>
                    <span>Qtde Volumes</span>
                    <InputForm
                      type="number"
                      id="nff_qtde_vol"
                      ref="nff_qtde_vol"
                      value={nff_qtde_vol}
                      onChange={this.onChange}
                    />
                  </Col>
                  <Col xs={24} sm={6} style={{ marginTop: -20, paddingRight: 20 }}>
                    <span>Peso Bruto</span>
                    <InputForm
                      type="number"
                      id="nff_peso_bruto"
                      ref="nff_peso_bruto"
                      value={nff_peso_bruto}
                      onChange={this.onChange}
                    />
                  </Col>
                  <Col xs={24} sm={6} style={{ marginTop: -20, paddingRight: 20 }}>
                    <span>Peso Liquido</span>
                    <InputForm
                      type="number"
                      id="nff_peso_liquido"
                      ref="nff_peso_liquido"
                      value={nff_peso_liquido}
                      onChange={this.onChange}
                    />
                  </Col>
                  <Col xs={24} sm={6} style={{ marginTop: -20 }} >
                    <span>Numeração</span>
                    <InputForm
                      id="nff_num_volumes"
                      ref="nff_num_volumes"
                      maxLength={9}
                      onChange={this.onChange}
                      value={nff_num_volumes}
                    />
                  </Col>
                  <Col xs={24} sm={12} style={{ marginTop: -20, paddingRight: 20 }} >
                    <span>Espécie</span>
                    <InputForm
                      id="nff_especie"
                      ref="nff_especie"
                      maxLength={9}
                      onChange={this.onChange}
                      value={nff_especie}
                    />
                  </Col>
                  <Col xs={24} sm={12} style={{ marginTop: -20 }} >
                    <span>Marca</span>
                    <InputForm
                      id="nff_marca"
                      ref="nff_marca"
                      maxLength={9}
                      onChange={this.onChange}
                      value={nff_marca}
                    />
                  </Col>
                </Row>
              </div>
            </TabPane>

            <TabPane tab="Inf. Complementares" key="infcompl">
              <div style={{ height: 300 }}>
                <Row>
                  <Col xs={24} style={{}}>
                    <span>Informações complementares de interesso do contribuinte</span>
                    <InputForm
                      id="nfinf_texto"
                      ref="nfinf_texto"
                      value={nfinf_texto}
                      type="textarea"
                      rows={9}
                      maxLength={9500}
                      onChange={this.onChange}
                      validator={value => Boolean(value)}
                    />
                  </Col>
                </Row>
              </div>
            </TabPane>

          </Tabs>
        </div>

        <div>
          <div className="divider-form" />
          <ItemForm>
            <Row>
              <Col xs={24}>
                {this.state.visualizar || caixaFechado ? null : (
                  <Button
                    type="primary"
                    htmlType="button"
                    loading={carregando}
                    onClick={this.onOK}
                    className="btn-salvar"
                  >
                    Emitir Nota
                  </Button>
                )}
                <Button
                  htmlType="button"
                  onClick={onFecharModalEmissaoNFeClick}
                  className="btn-fechar"
                >
                  Fechar
                </Button>
              </Col>
            </Row>
          </ItemForm>
        </div>

      </Modal >
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/NotaFiscalEmissaoComplForm.js